import type { BaseEntity } from '..';
import ODataEntity from '../odata/decorator';

@ODataEntity('', 'ReloadV2')
export default class Reload implements BaseEntity<string> {
    id?: string;
    title?: string;
    content?: string;
    type?: string;
    isRead?: boolean;
    isDeleted?: boolean;
}
export interface ReloadResponse {
    value?: Reload[];
    count?: number;
}
